const AllReportsSidebarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#B0B1B4"
    viewBox="0 0 32 32"
    {...props}
  >
    <g id="SVGRepo_iconCarrier">
      <path d="M6 11h4v17H6zm16 5v12h4V16zm-8 12h4V4h-4z"></path>
    </g>
  </svg>
);

export default AllReportsSidebarIcon;
